import { Card } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Box, Step, StepLabel, Stepper, Typography, StepConnector, StepIconProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const useStyles = () =>
    makeStyles(() =>
        createStyles({
            orderProgressBarText: {
                textAlign: "center",
                width: "25px",
                fontWeight: 400,
                color: "#ffffff",
                marginTop: "auto",
            },
            orderProgressPointDescription: {
                fontWeight: 300,
                textAlign: "left",
            },
            image: {
                width: "30px",
                height: "auto",
                position: "absolute",
                top: "5vh",
                left: "auto",
                cursor: "pointer",
            },
        })
    );

const nameSrcArray = ["Buat Ukuran", "Lihat Hasil", "Pilih Produk", "Pilih Pengiriman"];

const QConnector = styled(StepConnector)(({ theme }) => ({
    [`& .MuiStepConnector-line`]: {
        borderLeftWidth: 2,
        borderColor: "#B9B9B9",
        minHeight: 40,
    },
    [`&.Mui-completed .MuiStepConnector-line`]: {
        borderColor: "#1c1c1c",
    },
    [`&.Mui-active .MuiStepConnector-line`]: {
        borderColor: "#1c1c1c",
    },
}));

function CustomStepIcon(props: StepIconProps) {
    const { active, completed, icon } = props;
    const classes = useStyles()();

    return (
        <Box
            sx={{
                width: 25,
                height: 25,
                borderRadius: "50%",
                backgroundColor: completed || active ? "#1c1c1c" : "#B9B9B9",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: 500,
            }}
        >
            <Typography className={classes.orderProgressBarText} sx={{ fontSize: ".7rem", marginTop: '1px' }}>
                {icon}
            </Typography>
        </Box>
    );
}

interface BackButtonSegmentProps {
    currentIndex: number;
    onClose: () => void;
}

export default function VerticalProgress({ currentIndex, onClose }: BackButtonSegmentProps) {
    const classes = useStyles()();

    if (currentIndex === -1) {
        return null;
    }

    return (
        <Card
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
                borderRadius: 0,
                position: "sticky",
                top: 0,
                zIndex: 2,
            }}
        >
            <img onClick={onClose} className={classes.image} src={"https://studiosclo.uk/legacy/sur_monogram_minimum.svg"} alt="back to shop" />
            <Stepper connector={<QConnector />} activeStep={currentIndex} orientation="vertical" style={{ margin: "auto" }}>
                {nameSrcArray.map((label, index) => (
                    <Step key={index} style={{ marginBottom: "-8px", marginTop: "-8px" }}>
                        <StepLabel StepIconComponent={CustomStepIcon}>
                            <Typography className={classes.orderProgressPointDescription} sx={{ fontWeight: currentIndex === index ? "bold" : "normal", fontSize: ".8rem", marginTop: '2px', marginLeft: '10px' }}>
                                {label}
                            </Typography>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Card>
    );
}
